import React from 'react'
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {MenuItem, Grid} from "@material-ui/core/";
import { CountryCodes } from "../js-shared/lib/constants/CountryCodes";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTranslation } from "react-i18next";
import CallIcon from "@material-ui/icons/Call";
import InputAdornment from "@material-ui/core/InputAdornment";



function MobilePhoneInput(props) {
  const { t } = useTranslation();
  const [digits, setDigits] = React.useState(10)
  const [digitsError, setDigitsError] = React.useState(false)

  

  React.useEffect(() => {
    if (!props.registerScreen) {
      if(props.dialCode){
        let item = CountryCodes.filter( (item) => item.dial_code === props.dialCode );
        if(item[0]){
          props.setCountry(item[0].code);
        }
      }
    }
  }, [])

  const handleChange = (event) => {
    props.setCountry(event.target.value);
    let item = CountryCodes.filter((item) => item.code === event.target.value);
    props.setDialCode(item[0].dial_code);
  };
  
  const handleChangePhone = (event) => {
    let updatedPhone =  {...props.phone}
    let value = event.target.value;
    event.target.value = parseInt(value);
    updatedPhone = event.target.value;
    props.setPhone(updatedPhone);
    if(updatedPhone === 'NaN'){
      props.setPhone("");
      // alert("NaN")
    }
    if (digits !== null && updatedPhone.length < digits) {
      setDigitsError(true)
    }else{setDigitsError(false)}
  };

  return (
    <Grid container spacing={2}>
      {props.registerScreen && (
        <>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id="combo-box-demo"
              options={CountryCodes}
              disableClearable
              getOptionLabel={(option) =>
                option.flag +
                "  " +
                option.name +
                "  " +
                "(" +
                option.dial_code +
                ")"
              }
              defaultValue={CountryCodes[83]}
              onChange={(event, option) => {
                props.setDialCode(option.dial_code);
                if (option.digits) {
                  setDigits(option.digits);
                } else {
                  setDigits(null);
                  setDigitsError(false);
                }
              }}
              style={{ width: 200 }}
              renderInput={(params) => (
                <TextField {...params} label={t("Χώρα")} variant="outlined" />
              )}
              renderOption={(option) => (
                <React.Fragment>
                  <span>
                    {option.flag} {"  "}
                  </span>
                  {option.name} ({option.code}) {option.dial_code}
                </React.Fragment>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              variant="outlined"
              error={digitsError}
              helperText={digitsError && t("Μη έγκυρος αριθμός")}
              fullWidth
              id="lastName"
              label={t("Κινητό")}
              name="phone"
              value={props.phone}
              placeholder="69XXXXXXXX"
              onChange={handleChangePhone}
            />
          </Grid>
        </>
      )}
      {!props.registerScreen && (
        <>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id="combo-box-demo"
              disableClearable
              options={CountryCodes}
              getOptionLabel={(option) => " " + option.flag + "  " + option.name + "  " + "(" + option.dial_code + ")" }
              defaultValue={
                CountryCodes.filter(
                  (item) => item.dial_code === props.dialCode
                )[0]
              }
              onChange={(event, option) => {
                props.setDialCode(option.dial_code);
                if (option.digits) {
                  setDigits(option.digits);
                } else {
                  setDigits(null);
                  setDigitsError(false);
                }
              }}
              // style={{ width: 300 }}
              renderInput={(params) => (
                <TextField {...params} label={t("Χώρα")} variant="outlined" />
              )}
              renderOption={(option) => (
                <React.Fragment>
                  <span>
                    {option.flag} {"  "}
                  </span>
                  {option.name} ({option.code}) {option.dial_code}
                </React.Fragment>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              error={digitsError}
              helperText={digitsError && t("Μη έγκυρος αριθμός")}
              variant="outlined"
              fullWidth
              id="lastName"
              label={t("Κινητό")}
              name="phone"
              value={props.phone}
              placeholder="69XXXXXXXX"
              startIcon={<CallIcon />}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CallIcon style={{ color: "#999999" }} />
                  </InputAdornment>
                ),
              }}
              onChange={handleChangePhone}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
}

export default MobilePhoneInput